/*
 * @Description:
 * @Author: 刘宝顺
 * @Date: 2024-03-29 15:21:30
 * @LastEditTime: 2024-08-21 10:50:48
 * @LastEditors: 刘宝顺
 */
import request from '@/utils/request';

interface IExtendJson {
    defaultLatitude: string;
    defaultLongitude: string;
    defaultCustomerServiceNumber: string;
    h5WebUrl: string;
}
interface ICountryFromIpRes {
    countryName: string;
    countryIsoLanguageCode: string;
    countryIsoCode: string;
    regionUrl: string;
    sourceUrl: string;
    extendJson: IExtendJson;
}
// 获取系统配置
export const getCountryFromIp = async (): Promise<ICountryFromIpRes> => {
    return request({
        // 这个接口特殊，必须加域名
        url: `${process.env.APP_API}sys/countryCodeAndRegion/get`,
    });
};
